
import {computed, defineComponent, ref} from 'vue';
import axios from "axios";
import {message} from "ant-design-vue";
import store from "@/store";
declare let hexMd5:any;
declare let KEY:any;
export default defineComponent({
  name: 'the-header',
  setup(){
    // -------- 登录表单 ---------
    // 登录
    const loginUser = ref({
      loginName:'test',
      password:'test123'
    });
    // 登录后保存
    const user = computed(()=>store.state.user);
    const loginModalVisible = ref(false);
    const loginModalLoading = ref(false);
    const showLoginModel = () => {
      loginModalVisible.value = true;
    };
    /**
     * 登录
     */
    const login = () => {
      console.log("开始登录")
      loginModalLoading.value = true;
      // 前端md5加密
      loginUser.value.password = hexMd5(loginUser.value.password + KEY);
      axios.post("/user/login", loginUser.value).then((response) => {
        loginModalLoading.value = false;
        const data = response.data;
        if (data.success) {
          loginModalVisible.value = false;
          message.success("登录成功！");
          store.commit("setUser", data.content);
        } else {
          message.error(data.message);
        }
      });
    }
      /**
     * 退出登录
     */
    const logout = () => {
      console.log("开始退出登录")
      axios.get("/user/logout/"+ user.value.token).then((response) => {
        const data = response.data;
        if(data.success){
          message.success("退出登录成功！");
          store.commit("setUser",{});
        }else{
          message.error(data.message);
        }
      });
    };

    /**
     * 前端登录表单输入效验
     */
    const rules = {
      password: [
        { required: true, pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,32}$/, message: '请输入正确的密码格式！',  trigger: 'change' }
      ],
    };

    const handleClick = (value:any)=>{
      // console.log("菜单点击");
      if(value.key === 'welcome'){
        window.location.reload();
      }
      // 简化如下：
      // isShowWelcome.value = value.key === 'welcome';
    };

    return{
      loginModalVisible,
      loginModalLoading,
      loginUser,
      login,
      showLoginModel,
      user,
      logout,
      handleClick,
      rules,
    }
  }
});
